(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function () {
  var Expander = /*#__PURE__*/function () {
    function Expander(params) {
      _classCallCheck(this, Expander);

      this.expander = params.expander;
      this.button = this.expander.querySelector('.expander-btn');
      this.sentinel = this.expander.querySelector('.expander-sentinel');
      this.content = this.expander.querySelector('.expander-content');
      this.animation = null;
      this.toggled = false;
    }

    _createClass(Expander, [{
      key: "init",
      value: function init() {
        this.bindListeners();
      }
    }, {
      key: "bindListeners",
      value: function bindListeners() {
        var _this = this;

        this.button.addEventListener('click', function (e) {
          _this.toggleExpander();
        });
        window.addEventListener('resize', function (e) {
          _this.resizeExpander();
        });
      }
    }, {
      key: "resizeExpander",
      value: function resizeExpander() {
        if (this.toggled) {
          this.sentinel.style.height = this.content.scrollHeight + 'px';
        }
      }
    }, {
      key: "toggleExpander",
      value: function toggleExpander() {
        var expander = this.expander,
            content = this.content,
            sentinel = this.sentinel,
            toggled = this.toggled;

        if (!toggled) {
          gsap.to(sentinel, {
            duration: 0.4,
            height: content.scrollHeight
          });
          expander.classList.add('expander-content--active');
          this.toggled = true;
        } else {
          gsap.to(sentinel, {
            duration: 0.4,
            height: 0
          });
          expander.classList.remove('expander-content--active');
          this.toggled = false;
        }
      }
    }]);

    return Expander;
  }();

  var expanders = document.querySelectorAll('.expander');

  if (expanders !== null && expanders !== undefined) {
    expanders.forEach(function (expander) {
      new Expander({
        expander: expander
      }).init();
    });
  }
})();

},{}],2:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function () {
  var Modal = /*#__PURE__*/function () {
    function Modal(params) {
      _classCallCheck(this, Modal);

      this.modal = params.modal;
      this.triggers = document.querySelectorAll('.modal-trigger');
      this.wrappers = this.modal.querySelectorAll('.modal-wrapper');
      this.close = this.modal.querySelectorAll('.modal-close');
      this.animation = null;
    }

    _createClass(Modal, [{
      key: "init",
      value: function init() {
        this.animation = this.createAnimation();
        this.bindListeners();
        this.checkHash();
      }
    }, {
      key: "setupSubmenu",
      value: function setupSubmenu() {//
      }
    }, {
      key: "bindListeners",
      value: function bindListeners() {
        var _this = this;

        var triggers = this.triggers,
            close = this.close;
        triggers.forEach(function (trigger) {
          var id = trigger.dataset.trigger;
          trigger.addEventListener('click', function (e) {
            _this.toggleWrappers(id);

            _this.toggleModal();
          });
        });
        close.forEach(function (closeBtn) {
          closeBtn.addEventListener('click', function (e) {
            _this.toggleModal();
          });
        });
        window.addEventListener('hashchange', function (e) {
          _this.checkHash();
        });
      }
    }, {
      key: "toggleModal",
      value: function toggleModal() {
        this.animation.reversed() ? this.animation.play() : this.animation.reverse();
      }
    }, {
      key: "toggleWrappers",
      value: function toggleWrappers(id) {
        var wrappers = this.wrappers;
        console.log(id);
        wrappers.forEach(function (wrapper) {
          if (wrapper.dataset.trigger !== id) {
            wrapper.style.display = 'none';
          } else {
            wrapper.style.display = 'block';
          }
        });
      }
    }, {
      key: "checkHash",
      value: function checkHash() {
        var hash = window.location.hash;
        var wrappers = this.wrappers;
        if (hash == '') return;
        var hashExists = Array.from(wrappers).find(function (wrapper) {
          return wrapper.dataset.trigger == hash.substring(1);
        });

        if (hashExists !== undefined) {
          gsap.to(window, {
            duration: 0.6,
            scrollTo: {
              y: '.cards',
              offsetY: 190
            }
          });
          this.toggleWrappers(hash.substring(1));
          this.toggleModal();
        }
      }
    }, {
      key: "createAnimation",
      value: function createAnimation() {
        var animation = gsap.timeline({
          reversed: true
        });
        return animation.from(this.modal, {
          duration: 0.3,
          autoAlpha: 0,
          display: 'none'
        });
      }
    }]);

    return Modal;
  }();

  var modals = document.querySelectorAll('.modal');

  if (modals !== null && modals !== undefined) {
    modals.forEach(function (modal) {
      new Modal({
        modal: modal
      }).init();
    });
  }
})(); //
//
//


(function () {
  var ModalPopup = /*#__PURE__*/function () {
    function ModalPopup(params) {
      _classCallCheck(this, ModalPopup);

      this.modal = params.modal;
      this.wrappers = this.modal.querySelectorAll('.modal-wrapper');
      this.close = this.modal.querySelectorAll('.modal-close');
      this.animation = null;
    }

    _createClass(ModalPopup, [{
      key: "init",
      value: function init() {
        this.animation = this.createAnimation();
        this.bindListeners();
      }
    }, {
      key: "setupSubmenu",
      value: function setupSubmenu() {//
      }
    }, {
      key: "bindListeners",
      value: function bindListeners() {
        var _this2 = this;

        var close = this.close;
        setTimeout(function () {
          _this2.toggleWrappers('popup');

          _this2.toggleModal();
        }, 1500);
        close.forEach(function (closeBtn) {
          closeBtn.addEventListener('click', function (e) {
            _this2.toggleModal();
          });
        });
      }
    }, {
      key: "toggleModal",
      value: function toggleModal() {
        this.animation.reversed() ? this.animation.play() : this.animation.reverse();
      }
    }, {
      key: "toggleWrappers",
      value: function toggleWrappers(id) {
        var wrappers = this.wrappers;
        wrappers.forEach(function (wrapper) {
          if (wrapper.dataset.trigger !== id) {
            wrapper.style.display = 'none';
          } else {
            wrapper.style.display = 'block';
          }
        });
      }
    }, {
      key: "createAnimation",
      value: function createAnimation() {
        var animation = gsap.timeline({
          reversed: false
        });
        return animation.from(this.modal, {
          duration: 0.3,
          autoAlpha: 1,
          display: 'flex'
        });
      }
    }]);

    return ModalPopup;
  }();

  var modals = document.querySelectorAll('.modal--popup');

  if (modals !== null && modals !== undefined) {
    modals.forEach(function (modal) {
      new ModalPopup({
        modal: modal
      }).init();
    });
  }
})();

},{}],3:[function(require,module,exports){
"use strict";

require("../../extended-widgets/atom-expander/assets/atom-expander-script");

require("../../extended-widgets/atom-modal/assets/atom-modal-script");

},{"../../extended-widgets/atom-expander/assets/atom-expander-script":1,"../../extended-widgets/atom-modal/assets/atom-modal-script":2}]},{},[3]);
